// ============================================================================
// Clinician invitation flow (admin-issued).
//
// Admin endpoints are auth-gated and only an admin/staff/superuser can hit
// them. The preview + accept endpoints are deliberately public — the token
// in the URL is the only secret the invitee needs.
// ============================================================================

import { api } from './client.js'
import { unwrapList } from '../utils/format.js'

export async function listInvitations() {
  const { data } = await api.get('/api/doctor-invitations/', {
    params: { ordering: '-created_at', page_size: 100 },
  })
  return unwrapList(data)
}

export async function createInvitation(data) {
  const { data: created } = await api.post('/api/doctor-invitations/', data)
  return created
}

export async function revokeInvitation(id) {
  const { data } = await api.post(`/api/doctor-invitations/${id}/revoke/`)
  return data
}

/**
 * Resend the invitation email without minting a new token. Response includes
 * the freshly-serialized invitation with `email_status` reflecting the
 * dispatch outcome (task #49 — mirrors staff-invitation resend contract).
 */
export async function resendInvitation(id) {
  const { data } = await api.post(`/api/doctor-invitations/${id}/resend/`)
  return data
}

/**
 * Public preview — what an invitee sees on the accept page BEFORE they type
 * a password. Contains the intended role, specialty, and name so they can
 * confirm the invitation is for them.
 */
export async function previewInvitation(token) {
  const { data } = await api.get(`/api/invitations/${encodeURIComponent(token)}/`)
  return data
}

/**
 * Public accept — creates the User + DoctorProfile, returns { access,
 * refresh, user } so the client signs the new doctor in immediately.
 */
export async function acceptInvitation(token, body) {
  const { data } = await api.post(`/api/invitations/${encodeURIComponent(token)}/accept/`, body)
  return data
}
